import { useGetAllUsersQuery } from "@bonliva-crm/graphql";
import { useLocale } from "@hooks";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { UserSelectFilter } from "./_common/user-select-filter";

export type ManagedByFilterProps = FilterWithFavouriteProps;

export const ManagedByFilter = (
  props: ManagedByFilterProps
) => {
  const { locale } = useLocale();
  const title = props.label ?? locale.managedBy;

  const users = useGetAllUsersQuery({ fetchPolicy: "network-only" });

  const options = users.data?.users ?? [];

  return (
    <UserSelectFilter label={title} options={options} {...props} />
  );
};
